<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-bridge">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-7">
                <h1 class="display-3 text-white">{{ relation.title }}</h1>
                <p class="lead  text-white">{{ $t('relation.' + $route.params.id + '.description') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg mt--100 mb--100">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">{{ relation.title }}</h2>
            <p v-if="relation.text1" class="lead">{{ $t('relation.' + $route.params.id + '.text1') }}</p>
            <p v-if="relation.text2">{{ $t('relation.' + $route.params.id + '.text2') }}</p>
            <p v-if="relation.text3">{{ $t('relation.' + $route.params.id + '.text3') }}</p>
            <div
              v-if="relation.url"
              class="btn-wrapper">
              <a
                :href="relation.url"
                target="_blank"
                class="btn btn-warning mt-3">
                {{ $t('relation.buttonLink') }}
              </a>
            </div>
            <div class="px-4 mt-5">
              <img v-lazy="relation.src"
                   class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                   style="width: 200px;">
              <div class="pt-4 text-center">
                <h5 class="title">
                  <small v-if="relation.role" class="h6 text-muted">{{ $t('relation.role') }}</small>
                  <span v-if="relation.title" class="d-block mb-1">{{ relation.role }}</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import clientsData from '../data/clients.js';
  import employersData from "../data/employers";
  import listUtils from "../lib/listUtils";

  export default {
    name: "relations",
    computed: {
      relation() {
        return listUtils.findBySlug(this.$route.params.id, clientsData.concat(employersData))
      }
    }
  };
</script>
